<template>
  <b-form-group
    label="Choose CSV File:"
    label-cols="3"
    label-size="lg"
    :disabled="loading"
  >
    <b-file
      :value="csvFile"
      :state="Boolean(csvFile)"
      accept=".csv"
      placeholder="Choose a file..."
      data-cy="input-csv-upload"
      @input="$emit('update:csvFile', $event)"
    />
  </b-form-group>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  loading: Boolean,
  csvFile: {
    type: File,
    default: null,
  },
}

@Component
export default class UploadCSV extends Vue.extend({ props }) {}

</script>
